import script from "./examine.vue?vue&type=script&setup=true&lang=js"
export * from "./examine.vue?vue&type=script&setup=true&lang=js"

import "./examine.vue?vue&type=style&index=0&id=3d28e3e6&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d28e3e6"]])

export default __exports__